export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "harvest_team_work_log": {
            "worker_count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de trabajadores"])},
            "work_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Día"])},
            "worked_hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Horas trabajadas"])},
            "productivity_ratio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ratio"])},
            "harvest_team": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuadrilla"])}
          }
        }
      },
      "en": {
        "model": {
          "harvest_team_work_log": {
            "worker_count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# workers"])},
            "work_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Work date"])},
            "worked_hours": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Worked hours"])},
            "productivity_ratio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productivity ratio"])},
            "harvest_team": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Harvest team"])}
          }
        }
      }
    }
  })
}